export default "/assets/images/download-mila-app.png?62ae196d4800c0b8e1fedb8bcae28df4";